module.exports = __webpack_public_path__ + "img/n05.fb70d49f.png";